module.exports = __webpack_public_path__ + "img/white_video.96b43363.svg";